<template>
  <div class="case">
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px 40px' }"
      class="hidden-xs-only"
    >
      <div class="case-title">· 成功案例 ·</div>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in caseArr"
          :key="index"
          :span="8"
          :offset="0"
        >
          <img
            class="case-img"
            :src="item.image"
            alt=""
          >
          <div class="case-desc">
            {{item.desc}}
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
      class="hidden-sm-and-up"
    >
      <div class="case-title">· 成功案例 ·</div>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in caseArr"
          :key="index"
          :span="24"
          :offset="0"
        >
          <img
            class="case-img"
            :src="item.image"
            alt=""
          >
          <div class="case-desc">
            {{item.desc}}
          </div>
        </el-col>
      </el-row>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  name: 'CaseIndex',
  data () {
    return {
      caseArr: [
        {
          image: require('@/assets/home_case1.png'),
          desc: '东莞市国际货柜码头冷链水果消毒'
        },
        {
          image: require('@/assets/home_case2.png'),
          desc: '东莞市虎门港口岸熏蒸消毒工程'
        },
        {
          image: require('@/assets/home_case3.png'),
          desc: '东莞市人民政府办公室空气治理服务工程'
        },
        {
          image: require('@/assets/home_case4.png'),
          desc: '东莞市同沙林场薇甘菊防治'
        },
        {
          image: require('@/assets/home_case5.png'),
          desc: '东莞港口消毒演练'
        },
        {
          image: require('@/assets/home_case6.png'),
          desc: '东莞港船舶防疫消毒'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.case-title {
  text-align: center;
  color: #f7221d;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #f5dc2a;
  height: 28px;
  width: 450px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.case-img {
  width: 280px;
  height: 200px;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
}
.case-desc {
  text-align: center;
  margin: 16px 0 40px 0;
  font-size: 14px;
  color: #666;
}
@media screen and(max-width: 768px) {
  .case-title {
    width: 100%;
  }
  .kongxi {
    height: 10px;
  }
}
</style>
